/**
 * Reviews Section Carousel Component with Swiper
 */
import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export class ReviewsCarousel {
  constructor() {
    this.textCarousel = document.querySelector('[data-js="reviews-text-carousel"]');
    this.textSwiper = null;
    
    if (this.textCarousel) {
      this.initTextCarousel();
    }
  }

  initTextCarousel() {
    this.textSwiper = new Swiper(this.textCarousel, {
      modules: [Autoplay],
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      speed: 600,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        }
      }
    });
  }

  destroy() {
    if (this.textSwiper) {
      this.textSwiper.destroy();
      this.textSwiper = null;
    }
  }
}
